import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { IconModule } from '@visurel/iconify-angular';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { HeaderUserRoutingModule } from './header-user-routing.module';
import { HeaderUserComponent } from './header-user.component';


@NgModule({
  declarations: [
    HeaderUserComponent
  ],
  imports: [
    CommonModule,
    HeaderUserRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatBadgeModule,
    MatDividerModule,
    IconModule,
    CustomFlexLayoutModule
  ], exports: [
    HeaderUserComponent
  ]
})
export class HeaderUserModule { }
